"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var validator = require("validator");
var toastr = require("toastr");
var _ = require("lodash");
var YouTubeService = (function () {
    function YouTubeService($rootScope) {
        "ngInject";
        var _this = this;
        this.$rootScope = $rootScope;
        gapi.load("client:auth2", function () {
            gapi.client.init({
                clientId: "871050293069-eqou5jodn7u9tahldd0jqdhu10mlk13f.apps.googleusercontent.com",
                scope: "https://www.googleapis.com/auth/youtube"
            }).then(function () {
                _this.googleAuth = gapi.auth2.getAuthInstance();
                _this.googleAuth.isSignedIn.listen(_this.updateSignInStatus.bind(_this));
                _this.$rootScope.isAuthorized = _this.googleAuth.isSignedIn.get();
                _this.$rootScope.currentUser = _this.getCurrentUser();
                _this.$rootScope.$apply();
            });
        });
    }
    Object.defineProperty(YouTubeService.prototype, "isAuthorized", {
        get: function () {
            return this.$rootScope.isAuthorized;
        },
        enumerable: true,
        configurable: true
    });
    YouTubeService.prototype.login = function () {
        var _this = this;
        return this.googleAuth.signIn().then(function () {
            _this.$rootScope.currentUser = _this.getCurrentUser();
            _this.$rootScope.$apply();
        });
    };
    YouTubeService.prototype.logout = function () {
        this.googleAuth.signOut();
    };
    YouTubeService.prototype.checkVideos = function (videosList) {
        var videos = videosList.split("\n");
        var videoIds = _.uniq(videos.map(function (video) {
            var result;
            if (validator.isURL(video)) {
                result = queryString.parse(queryString.extract(video)).v;
            }
            else {
                result = video;
            }
            return result;
        }));
        var videoIdsChunks = _.chunk(videoIds, 580);
        return gapi.client.load("youtube", "v3").then(function () {
            var promises = [];
            videoIdsChunks.forEach(function (videoIdsChunk) {
                var promise = gapi.client.youtube.videos.getRating({
                    id: videoIdsChunk.join(",")
                });
                promises.push(promise);
            });
            return Promise.all(promises);
        })
            .then(function (responses) {
            var result = new CheckingResult();
            var withLikes = [];
            var withoutLikes = [];
            for (var i = 0; i < responses.length; i++) {
                var response = responses[i];
                var items = response.result.items;
                for (var i_1 = 0; i_1 < items.length; i_1++) {
                    var item = items[i_1];
                    if (item.rating !== "like") {
                        withoutLikes.push(item.videoId);
                    }
                    else {
                        withLikes.push(item.videoId);
                    }
                }
            }
            result.withLikes = withLikes;
            result.withoutLikes = withoutLikes;
            return result;
        }, function (data) {
            console.error(data);
            toastr.error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0438\u0434\u0435\u043E.");
            return null;
        });
    };
    YouTubeService.prototype.setRating = function (videoIds, rating, onSuccess, onError) {
        return gapi.client.load("youtube", "v3").then(function () {
            var promises = [];
            videoIds.forEach(function (videoId, index) {
                var promise = gapi.client.youtube.videos.rate({
                    id: videoId,
                    rating: rating
                }).then(function () {
                    if (onSuccess) {
                        onSuccess(videoId);
                    }
                }, function (data) {
                    toastr.error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043B\u0430\u0439\u043A \u043D\u0430 \u0432\u0438\u0434\u0435\u043E \u0441 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043E\u043C " + videoId + ". " + data.result.error.message);
                    console.error(data);
                    if (onError) {
                        onError(videoId, data.result.error.message);
                    }
                });
                promises.push(promise);
            });
            return Promise.all(promises);
        });
    };
    YouTubeService.prototype.updateSignInStatus = function (isSignedIn) {
        this.$rootScope.isAuthorized = isSignedIn;
        this.$rootScope.$apply();
    };
    YouTubeService.prototype.getCurrentUser = function () {
        return this.googleAuth.currentUser.get().getBasicProfile();
    };
    return YouTubeService;
}());
exports.YouTubeService = YouTubeService;
var CheckingResult = (function () {
    function CheckingResult() {
    }
    return CheckingResult;
}());
exports.CheckingResult = CheckingResult;



/** WEBPACK FOOTER **
 ** ./src/app/common/youtube/youtube.service.ts
 **/